import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import ParkinglocationModel from './ParkinglocationModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/parkingconn/parking-locations';

export default new class ParkingConnlocationsModel {

    get(id) {
        return new Promise((resolve, reject) => {
            this.getAll()
                .then((data) => {
                    resolve(_.find(data, { id: id }));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll(parkinglocationId = null) {
        var filter = { order: "name ASC" };
        if (parkinglocationId) {
            filter = _.merge(filter, { where: { and: [{ coreParkingLocationId: parkinglocationId }] } });
        }
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: filter
                }
            })
                .then((response) => {
                    ParkinglocationModel.getAll(true)
                        .then((pl) => {
                            let data = [];
                            response.data.map(async (child, idx) => {
                                let location = _.find(pl, { id: child.coreParkingLocationId });
                                location
                                    ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                                    : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                            });
                            resolve(data);
                        });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        if (data.confirmPassword !== undefined) {
            delete data.confirmPassword;
        }
        return new Promise((resolve, reject) => {
            axios.post(BASE, Object.assign({}, data), {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.put(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    patch(id, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        if (data.confirmPassword !== undefined) {
            delete data.confirmPassword;
        }
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/ParkingConnlocationsModel.js